/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateFilterRequest
 */
export interface DateFilterRequest {
    /**
     * 
     * @type {string}
     * @memberof DateFilterRequest
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof DateFilterRequest
     */
    endDate: string;
}

/**
 * Check if a given object implements the DateFilterRequest interface.
 */
export function instanceOfDateFilterRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;

    return isInstance;
}

export function DateFilterRequestFromJSON(json: any): DateFilterRequest {
    return DateFilterRequestFromJSONTyped(json, false);
}

export function DateFilterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateFilterRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': json['startDate'],
        'endDate': json['endDate'],
    };
}

export function DateFilterRequestToJSON(value?: DateFilterRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startDate': value.startDate,
        'endDate': value.endDate,
    };
}

